"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTINUE_DEAL_PAGE = "/online-shopper/continue-deal";
exports.LEAD_FORM_PAGE = "/online-shopper/lead-form";
exports.PAYMENT_BUILDER_PAGE = "/online-shopper/payment-builder";
exports.MY_GARAGE_PAGE = "/online-shopper/my-garage";
exports.ACCESS_GARAGE_PAGE = "/online-shopper/access-my-garage";
exports.UNLOCK_GARAGE_PAGE = "/online-shopper/unlock-garage";